<template>
    <section
        class="roadmap section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="roadmap-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <c-timeline>
                    <c-timeline-item title="May 2012">
                        We started the logistic businesses since 2012
                    </c-timeline-item>
                    <c-timeline-item title="May 2020">
                        We started the import logistic business.
                    </c-timeline-item>
                    <c-timeline-item title="May 2022">
                        We moved our warehouse to kewdale next to the 77G depots.
                    </c-timeline-item>
                    <c-timeline-item title="December 2024">
                        the Custom broker liscense was granted in 2024
                    </c-timeline-item>                                                                        
                </c-timeline>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CTimeline from '@/components/elements/Timeline.vue'
import CTimelineItem from '@/components/elements/TimelineItem.vue'

export default {
  name: 'CRoadmap',
  components: {
    CSectionHeader,
    CTimeline,
    CTimelineItem
  },  
  mixins: [SectionProps],
  data() {
    return {
      sectionHeader: {
        title: 'Company roadmap',
        paragraph:
          'Run sustainable business over decades'
      }
    }
  }  
}
</script>